// src/components/stats/HitRateCard.jsx -- presentational hit-rate card. Receives
// the already-computed { cleared, total } and line/mode; owns no math. Over/Under
// toggle (default Over) and a 0.5-step line stepper report changes upward. Honest
// "X of Y games cleared" -- no push language anywhere (§A3/§D). Spec §C4.
// Signal Scarcity (UI critique PR 3): the percentage is a research figure, not a bet outcome,
// so it renders neutral (text.primary) at every value. Colors come from JT (Readable Floor).
import { JT } from "../ui/jumbotronTokens";

export default function HitRateCard({ statDef, mode, line, hitRate, onToggleMode, onLineChange }) {
  // The percentage is computed in computeHitRate (§D); this card only renders it.
  const { cleared, total, pct } = hitRate;

  const modeBtn = (m, label) => (
    <button
      type="button"
      onClick={() => onToggleMode(m)}
      aria-pressed={mode === m}
      style={{
        flex: 1, cursor: 'pointer', fontFamily: 'inherit', fontWeight: 800, fontSize: 13,
        padding: '8px 0', borderRadius: 8, border: 'none',
        background: mode === m ? JT.brand.cta : 'transparent', color: mode === m ? JT.text.primary : JT.text.secondary,
      }}
    >
      {label}
    </button>
  );

  return (
    <div style={{ background: JT.bg.tile, border: `1px solid ${JT.border.mid}`, borderRadius: 16, padding: 16, marginTop: 4 }}>
      <div style={{ marginBottom: 10 }}>
        <div style={{
          ...JT.type.label, fontWeight: 800, color: JT.text.secondary,
          letterSpacing: '1px', marginBottom: 3,
        }}>
          Hit Rate vs Line
        </div>
        <div style={{ fontSize: 12, color: JT.text.tertiary, lineHeight: 1.5 }}>
          How often this player cleared the line in recent games.
          Adjust the line to match your bet.
        </div>
      </div>
      <div style={{ display: 'flex', background: JT.bg.root, borderRadius: 10, padding: 4, marginBottom: 14 }}>
        {modeBtn('over', 'Over')}
        {modeBtn('under', 'Under')}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 14, marginBottom: 12 }}>
        <button type="button" onClick={() => onLineChange(-0.5)} aria-label="decrease line"
          style={{ width: 34, height: 34, borderRadius: '50%', border: `1px solid ${JT.border.mid}`, background: JT.bg.root, color: JT.text.primary, fontSize: 18, cursor: 'pointer' }}>−</button>
        <div style={{ textAlign: 'center', minWidth: 90 }}>
          <div style={{ fontSize: 26, fontWeight: 800, color: JT.text.primary }}>{line}</div>
          <div style={{ fontSize: 11, fontWeight: 700, color: JT.text.secondary }}>{statDef.shortLabel} LINE</div>
        </div>
        <button type="button" onClick={() => onLineChange(0.5)} aria-label="increase line"
          style={{ width: 34, height: 34, borderRadius: '50%', border: `1px solid ${JT.border.mid}`, background: JT.bg.root, color: JT.text.primary, fontSize: 18, cursor: 'pointer' }}>+</button>
      </div>

      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 30, fontWeight: 800, color: JT.text.primary }}>{pct}%</div>
        <div style={{ fontSize: 13, color: JT.text.body, fontWeight: 700, marginTop: 2 }}>
          {cleared} of {total} games cleared
        </div>
      </div>
    </div>
  );
}
